import "./styles.scss";

import SelectablePill from "components/SelectablePill";

const mainClass = "pill-grid-new";

const PillGridNew = ({
  header,
  label,
  selected,
  icon,
  options,
  optionsFooter,
  onChange,
}) => {
  const options_selected =
    options?.filter((item) => selected?.split(",")?.includes(item?.key)) || [];

  const handleOnChange = (option) =>
    typeof onChange === "function" ? onChange(option) : undefined;

  const isInline = options === undefined || options === null;

  return (
    <div className={mainClass}>
      {!!header && <p className={`${mainClass}__header`}>{header}</p>}
      <div className={`${mainClass}__items`}>
        {options_selected?.length > 0 &&
          options_selected.map((selected) => (
            <div key={selected.value}>
              <SelectablePill
                data={{ type: "remove", ...selected }}
                icon={icon}
                onClick={(option) => handleOnChange(option)}
              />
            </div>
          ))}
        {options_selected?.length !== options?.length && (
          <SelectablePill
            data={{
              type: isInline ? "inline" : "picker",
              value: "picker",
              label: label ?? "Select",
            }}
            icon={icon}
            options={options?.filter(
              (option) =>
                !options_selected?.some(
                  (selected) => selected?.value === option?.value
                )
            )}
            optionsFooter={optionsFooter}
            isSelected={isInline && !!selected}
            onClick={isInline ? (option) => handleOnChange(option) : undefined}
            onChange={(option) => handleOnChange(option)}
          />
        )}
      </div>
    </div>
  );
};

export default PillGridNew;
